export default __webpack_public_path__ + "static/media/editor-toolbar-icon-bold.b3d2f038.svg";